import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { toggleModal } from 'store/ui/actions';

import {
    addToCanvas,
    clearCanvas,
    clearError,
    clearSelectedFilters,
    loadStyleRequest,
    setCanvasLayout,
    setCanvasSizeIndex,
    updateCanvasDataUrl,
    updateGender,
    updateStyleRequest
} from '../../redux/reducers/stylingRoom/actions';
import { StylingRoom as StylingRoomComponent } from './StylingRoom';

const mapStateToProps = ({
    user: { user },
    stylingRoom: { loading, loadingFilters, styleRequest, canvasLayout, revision }
}) => ({
    user,
    loading,
    loadingFilters,
    styleRequest,
    canvasLayout,
    revision
});

const mapDispatchToProps = (dispatch) => ({
    clearCanvas: () => dispatch(clearCanvas()),
    loadStyleRequest: (uuid) => dispatch(loadStyleRequest(uuid)),
    updateStyleRequest: (request) => dispatch(updateStyleRequest(request)),
    toggleModal: (data) => toggleModal(dispatch, data),
    updateCanvasDataUrl: (dataUrl) => dispatch(updateCanvasDataUrl(dataUrl)),
    addToCanvas: (item) => dispatch(addToCanvas(item)),
    updateGender: (gender) => dispatch(updateGender(gender)),
    clearSelectedFilters: () => dispatch(clearSelectedFilters()),
    setCanvasLayout: (layout) => dispatch(setCanvasLayout(layout)),
    setCanvasSizeIndex: (size) => dispatch(setCanvasSizeIndex(size)),
    clearError: () => dispatch(clearError())
});

export const StylingRoom = withRouter(
    connect(mapStateToProps, mapDispatchToProps)(StylingRoomComponent)
);
